export default __webpack_public_path__ + "static/media/Sadistic Probe.6582dee4.jpg";